import { endpointFundGET, FundGetData } from '~/api/def/endpoints/fundEndpoint';
import { BaseSearchProps, ExtendedDocCompareChunkFinderChunk } from '../types';

const convertFundToSearchResult = (
  fund: FundGetData,
): ExtendedDocCompareChunkFinderChunk => {
  const fundDetails = `
Fund Name: ${fund.name}
Inception Date: ${new Date(fund.inceptionDate).toLocaleDateString()}
Termination Date: ${new Date(fund.terminationDate).toLocaleDateString()}
Size: ${fund.size} ${fund.currency}
Jurisdiction: ${fund.jurisdiction.name}
${fund.investmentFocus ? `Investment Focus: ${fund.investmentFocus}` : ''}
${fund.status ? `Status: ${fund.status}` : ''}
${fund.currentNav !== undefined ? `Current NAV: ${fund.currentNav}` : ''}
${fund.assetDeployed !== undefined ? `Asset Deployed: ${fund.assetDeployed}` : ''}
${fund.portfolioCompanyCount !== undefined ? `Portfolio Company Count: ${fund.portfolioCompanyCount}` : ''}
  `;

  return {
    id: fund.id,
    document_id: fund.id,
    document_name: fund.name,
    client_id: '',
    text: fundDetails.trim(),
    type: 'Funds',
    fund_id: fund.id,
    bbox_page_start: 0,
    bbox_page_end: 0,
    bbox_x1: 0,
    bbox_y1: 0,
    bbox_x2: 0,
    bbox_y2: 0,
    _originalFund: fund,
  };
};

export const searchFunds = async ({
  searchTerm,
  onSuccess,
  onError,
  onEmpty,
}: BaseSearchProps<ExtendedDocCompareChunkFinderChunk>): Promise<void> => {
  try {
    const response = await endpointFundGET();

    if (response?.success === 1 && Array.isArray(response.data)) {
      const funds = response.data;
      const searchLower = searchTerm.toLowerCase();

      const filteredFunds = funds.filter((fund: FundGetData) => {
        const nameMatch = fund.name.toLowerCase().includes(searchLower);
        const jurisdictionMatch = fund.jurisdiction?.name
          ?.toLowerCase()
          .includes(searchLower);
        const investmentFocusMatch = fund.investmentFocus
          ?.toLowerCase()
          .includes(searchLower);
        const statusMatch = fund.status?.toLowerCase().includes(searchLower);

        return (
          nameMatch || jurisdictionMatch || investmentFocusMatch || statusMatch
        );
      });

      const searchResults = filteredFunds.map(convertFundToSearchResult);

      if (searchResults.length === 0) {
        onEmpty?.();
      } else {
        onSuccess?.(searchResults);
      }
    } else {
      onEmpty?.();
    }
  } catch (error) {
    onError?.(error as Error);
  }
};
